<template>
  <page class="ad-page">
    <r-title>{{instruction.title}}</r-title>
    <ad-steps :steps="instruction.steps"></ad-steps>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import RTitle from '@/components/common/Title.vue';
import AdSteps from '@/components/ad/AdSteps.vue';
import instructions from './instructions';

export default {
  components: {
    Page,
    RTitle,
    AdSteps,
  },
  props: ['type'],
  computed: {
    instruction() {
      return instructions[this.type];
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-page {
  padding: 20px;
}
</style>
